import React from "react";

// Tiny 7x7-cell pixel glyphs rendered in currentColor — the site's
// icon language. Each glyph is a list of [col, row] filled cells.
const range = (a, b) => Array.from({ length: b - a + 1 }, (_, i) => a + i);
const row = (y, x1, x2) => range(x1, x2).map((x) => [x, y]);
const col = (x, y1, y2) => range(y1, y2).map((y) => [x, y]);

const GLYPHS = {
  // diamond sparkle — AI
  spark: [
    [3, 0],
    ...row(1, 2, 4),
    ...row(2, 1, 5),
    ...row(3, 0, 6),
    ...row(4, 1, 5),
    ...row(5, 2, 4),
    [3, 6],
  ],
  // two interlocked square links — blockchain / web3
  chain: [
    ...row(1, 0, 3),
    [0, 2], [3, 2],
    [0, 3], [3, 3],
    ...row(4, 0, 3),
    ...row(2, 3, 6),
    [6, 3],
    [6, 4],
    ...row(5, 3, 6),
  ],
  // layered bars — scalable architecture
  stack: [...row(1, 1, 5), ...row(3, 0, 6), ...row(5, 1, 5)],
  // browser window — SaaS / full-stack product
  window: [
    ...row(0, 0, 6),
    [0, 1], [6, 1],
    ...row(2, 0, 6),
    [0, 3], [6, 3],
    [0, 4], [6, 4],
    [0, 5], [6, 5],
    ...row(6, 0, 6),
  ],
  // ring + center — consulting / focus
  target: [
    ...row(1, 1, 5),
    [1, 2], [5, 2],
    [1, 3], [5, 3],
    [1, 4], [5, 4],
    ...row(5, 1, 5),
    [3, 3],
  ],
  // up-and-right arrow — growth / marketing
  arrow: [
    ...row(0, 3, 6),
    [6, 1], [6, 2],
    [5, 1],
    [4, 2],
    [3, 3],
    [2, 4],
    [1, 5],
    [0, 6],
  ],
  // little rocket — shipping
  rocket: [
    [3, 0],
    ...row(1, 2, 4),
    ...row(2, 2, 4),
    ...row(3, 1, 5),
    [2, 4], [4, 4],
    [3, 5],
    [2, 6], [4, 6],
  ],
  // envelope — email
  mail: [
    ...row(0, 0, 6),
    [0, 1], [1, 1], [5, 1], [6, 1],
    [0, 2], [2, 2], [4, 2], [6, 2],
    [0, 3], [3, 3], [6, 3],
    [0, 4], [6, 4],
    ...row(5, 0, 6),
  ],
  // clock face with hands — response time
  clock: [
    ...row(0, 2, 4),
    [1, 1], [5, 1],
    [0, 2], [6, 2],
    [0, 3], [3, 3], [4, 3], [6, 3],
    [0, 4], [3, 2], [6, 4],
    [1, 5], [5, 5],
    ...row(6, 2, 4),
  ],
  // flag on a pole — location
  flag: [
    ...col(1, 0, 6),
    ...row(0, 2, 5),
    ...row(1, 2, 5),
    ...row(2, 2, 4),
  ],
};

const PixelIcon = ({ name, size = 22 }) => {
  const cells = GLYPHS[name];
  if (!cells) return null;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 14 14"
      aria-hidden="true"
      focusable="false"
      style={{ shapeRendering: "crispEdges" }}
    >
      {cells.map(([x, y], i) => (
        <rect key={i} x={x * 2} y={y * 2} width="2" height="2" fill="currentColor" />
      ))}
    </svg>
  );
};

export default PixelIcon;
